const originalFetch = window.fetch;

function generateUUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

function getStoredTraceId(): string | null {
  return sessionStorage.getItem('trace-id');
}

function setStoredTraceId(traceId: string): void {
  sessionStorage.setItem('trace-id', traceId);
}

let excludedDomains: string[] = [];

export function initTraceIdInterceptor(domains: string[]): void {
    excludedDomains = excludedDomains.concat(domains);
}

function isExcludedDomain(url: string): boolean {
    return excludedDomains.some(domain => url.includes(domain));
}

const customFetch: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response> = async function(input, init = {}) {
  // Convert input to string URL for checking
  const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;

  if (!isExcludedDomain(url)) {
    let traceId = getStoredTraceId();
    if (!traceId) {
      traceId = generateUUID(); // Generate a new trace-id if not found
      setStoredTraceId(traceId);
    }

    // attach the trace-id to the headers if it exists
    if (!init.headers) {
      init.headers = {};
    }
    (init.headers as Record<string, string>)["trace-id"] = traceId;
  }

  const response = await originalFetch(input, init);
  const newTraceId = response.headers.get("trace-id");
  if (newTraceId) {
    setStoredTraceId(newTraceId);
  }
  return response;
};

window.fetch = customFetch;
